module.exports = __webpack_public_path__ + "media/images/emblems/La_Praz-coat_of_arms-9c493bc3c83c4f4645168fa81c229a5e.svg";